@if ((metersByContractActionState$ | async).pending) {
  <rs-web-loading-skeleton
    [show]="true"
    [types]="[LoadingType.HEADER, LoadingType.CONSUMPTION]"
  ></rs-web-loading-skeleton>
} @else {
  <div class="d-flex flex-column position-relative mb-4">
    <div class="consumption-widget__header mobile">
      @let showContractPicker = (onlyExpiredContractsAndActiveMembership$ | async) === false;
      <div class="consumption-widget__title">
        <h4 class="title-m">{{ 'dashboard.consumption_widget_l' | translate }}</h4>
        @if (showContractPicker && hasSingleContract()) {
          <rs-web-contract-picker
            [contracts]="contractOptions()"
            [contractId]="selectedContractId()"
            (contractIdChange)="selectContract($event)"
          ></rs-web-contract-picker>
        }
      </div>

      @if (showContractPicker && !hasSingleContract()) {
        <rs-web-contract-picker
          class="consumption-widget__contract-select"
          [contracts]="contractOptions()"
          [contractId]="selectedContractId()"
          (contractIdChange)="selectContract($event)"
        ></rs-web-contract-picker>
      }
    </div>

    <rs-web-consumption-dashboard-cards
      [metersByContract]="metersByContract$ | async"
    ></rs-web-consumption-dashboard-cards>
  </div>
}
